import React from "react";
import {Button, Form, Icon, Modal, Radio, Slider, Switch, Upload} from "antd";
import {GeneratorFilter} from "../../../../filters/Generator";
import Input from "antd/es/input";
import {WasteStreamFilter} from "../../../../filters/WasteStreamCode";

const FormItem = Form.Item;
const moment = require('moment');
const RadioGroup = Radio.Group;

class AddWasteProfileForm extends React.Component {
    state = {
        propertyValue: "solid",
        sliderValue: '75',
    };
    onChangeProperty = (e) => {
        console.log('radio checked', e.target.value);
        this.setState({
            propertyValue: e.target.value,
        });
    };
    onChangeSlider = (value) => {
        this.setState({
            sliderValue: value,
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {moderated, visible} = this.props;
        const {sliderValue} = this.state;
        return (
            <Modal title="Add Waste Profile Record" style={{background:"#ffffff"}} className="create-quote-btn" centered
                   visible={visible} okText="Add Waste Profile"
                   onOk={this.props.onCancel}
                   onCancel={this.props.onCancel} width="70%" destroyOnClose={true}>
                <div className="col-xs-12 paddingZ add-item-inner floating-form">
                    <Form>
                        <div className="row full-floating-inputs">
                            <div className="col-sm-6 col-12 pos-relative">
                                <div className="floating-label">
                                    <FormItem label="Generator">
                                        {getFieldDecorator('generator', {
                                            rules: [{required: true, message: 'Please select generator'}],
                                        })(<GeneratorFilter onRef={ref => (this.generator = ref)}/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-6 col-12">
                                <div className="floating-label">
                                    <FormItem label="Waste Stream">
                                        {getFieldDecorator('waste_stream', {
                                            rules: [{required: true, message: 'Please select Waste Stream'}],
                                        })(<WasteStreamFilter/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="floating-label">
                                    <FormItem label="Process Description">
                                        {getFieldDecorator('bill_to', {
                                            rules: [{required: true, message: 'Please select bill to'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Composition(must add upto 100%)">
                                        {getFieldDecorator('bill_to', {
                                            rules: [{required: true, message: 'Please select bill to'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-2 col-12 padding-0">
                                <div className="floating-label">
                                    <FormItem label=" ">
                                        {getFieldDecorator('percent')(<Input init={"000"} placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-6 col-12">
                                <FormItem label="Physical Properties">
                                    <div className="row">
                                        <div className="col-sm-8 col-12">
                                            <RadioGroup onChange={this.onChangeProperty}
                                                        value={this.state.propertyValue}>
                                                <Radio value={"liquid"}>Liquid</Radio>
                                                <Radio value={"solid"}>Solid</Radio>
                                            </RadioGroup>
                                        </div>
                                        <div className="col-sm-4 col-12 layered-div ">
                                            <p>Layered</p>
                                            <Switch defaultChecked checkedChildren="Yes" unCheckedChildren="No"/>
                                        </div>
                                        <div className="col-sm-10 col-12 value-slider">
                                            <Slider defaultValue={75} onChange={this.onChangeSlider}
                                                    tooltipVisible={true}/>
                                            <span className="slider-val">{sliderValue + '%'}</span>
                                        </div>
                                    </div>
                                </FormItem>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Color">
                                        {getFieldDecorator('color', {
                                            rules: [{required: true, message: 'Please select color'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Order">
                                        {getFieldDecorator('order', {
                                            rules: [{required: true, message: 'Please enter order'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Flash Point">
                                        {getFieldDecorator('flash_point', {
                                            rules: [{required: true, message: 'Please select flash point'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="pH">
                                        {getFieldDecorator('ph', {
                                            rules: [{required: true, message: 'Please enter pH'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Total Halogen">
                                        {getFieldDecorator('total_halogen', {
                                            rules: [{required: true, message: 'Please enter'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="PCB'S">
                                        {getFieldDecorator('pcb', {
                                            rules: [{required: true, message: 'Please select'}],
                                        })(<Input placeholder="Enter Here"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="floating-label">
                                    <FormItem label="Is there laboratory analysis?">
                                        {getFieldDecorator('laboratory', {
                                            rules: [{required: true, message: 'Please enter'}],
                                        })(
                                            <div>
                                                <Switch defaultChecked checkedChildren="Yes" unCheckedChildren="No"/>
                                                <br/>
                                                <Upload>
                                                    <Button>
                                                        <Icon type="upload"/> Choose File
                                                    </Button>
                                                </Upload>
                                            </div>)}
                                    </FormItem>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal>
        )
    }
}

export const AddWasteProfile = Form.create()(AddWasteProfileForm);



// WEBPACK FOOTER //
// ./src/pages/analytics/in_development/popups/AddWasteProfile.jsx